import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import themes from "./styles/theme";
import { GlobalStyle } from "./styles/globalStyles";
import { PatientDataProvider } from "./context/PatientDataContext";

import Layout from "./components/layouts/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/404/NotFound";

import routesConfig from "./routes/routesConfig";

export default function App() {
  const [collapsed, setCollapsed] = useState(false);

  const publicRoutes = routesConfig.filter(r => r.public);
  const privateRoutes = routesConfig.filter(r => !r.public);

  return (
    <ThemeProvider theme={themes.blue}>
      <GlobalStyle />
      <Router>
        <PatientDataProvider>

          <Routes>

            {/* 🟦 RUTAS PÚBLICAS (SIN NAVBAR) */}
            {publicRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}

            {/* 🟩 RUTAS PRIVADAS (CON NAVBAR / LAYOUT) */}
            <Route path="/" element={
                <Layout
                  collapsed={collapsed}
                  toggleSidebar={() => setCollapsed(!collapsed)}
                />
              }
            >
              {privateRoutes.map(({ path, element, permission }) => (
                <Route key={path} path={path}
                  element={
                    <ProtectedRoute requiredPermission={permission}>
                      {element}
                    </ProtectedRoute>
                  }
                />
              ))}
            </Route>

            {/* 🟥 404 SIN NAVBAR */}
            <Route path="*" element={<NotFound />} />

          </Routes>

        </PatientDataProvider>
      </Router>
    </ThemeProvider>
  );
}

